import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

var firebaseConfig = {
	apiKey: "AIzaSyCWWsAyfNsj4yG02uRnxAeQOIu7492wyuc",
	authDomain: "unity-61a0c.firebaseapp.com",
	databaseURL: "https://unity-61a0c.firebaseio.com",
	projectId: "unity-61a0c",
	storageBucket: "unity-61a0c.appspot.com",
	messagingSenderId: "1031699889506",
	appId: "1:1031699889506:web:fe98c4ded482fd7bff003b"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
